import Menu from 'Models/Menu';

export default [
  Menu.organizationInformation,
  Menu.logoCreate,
  Menu.organizationEdit,
  Menu.editOrgAssets,
  // Menu.organizationDelete,
  // Menu.organizationClone,
  // Menu.organizationsHelp,
];
